<template>
    <div>
        <card-header title="Course Categories" icon="fa-folder-tree"/>

        <card-toolbar>
            <button @click="$openCard('new-course-category', {certificationId: certificationId}, card)">
                <i class="far fa-plus"></i>New Category
            </button>
        </card-toolbar>

        <card-body>
            <card-list>
                <template v-if="categories.length === 0">
                    <container-list-item class="has-text-centered py-4">
                        <p class="has-text-grey">No categories found for this certification.</p>
                    </container-list-item>
                </template>

                <template v-for="category in categories">
                    <navigation-list-item
                        :key="category.id"
                        @click="$openCard('edit-course-category', {categoryId: category.id}, card)"
                        :active="child && child.definition.component === 'edit-course-category' && child.props.categoryId == category.id"
                    >
                        <template v-slot:icon>
                            <i class="fal fa-folder fa-fw"></i>
                        </template>
                        <template v-slot:content>
                            <strong>{{ category.title }}</strong>
                            <p v-if="category.description" class="has-text-grey is-size-7">{{ category.description }}</p>
                        </template>
                        <template v-slot:right>
                            <span class="tag is-light" v-if="category.children && category.children.length > 0">
                                {{ category.children.length }} subcategories
                            </span>
                        </template>
                    </navigation-list-item>

                    <!-- Subcategories -->
                    <template v-if="category.children && category.children.length > 0">
                        <navigation-list-item
                            v-for="child in category.children"
                            :key="child.id"
                            class="pl-5"
                            @click="$openCard('edit-course-category', {categoryId: child.id}, card)"
                            :active="child && child.definition && child.definition.component === 'edit-course-category' && child.props.categoryId == child.id"
                        >
                            <template v-slot:icon>
                                <i class="fal fa-folder-open fa-fw has-text-grey"></i>
                            </template>
                            <template v-slot:content>
                                <span>{{ child.title }}</span>
                                <p v-if="child.description" class="has-text-grey is-size-7">{{ child.description }}</p>
                            </template>
                        </navigation-list-item>
                    </template>

                    <!-- Add subcategory button -->
                    <navigation-list-item
                        :key="'add-' + category.id"
                        class="pl-5"
                        @click="$openCard('new-course-category', {certificationId: certificationId, parentId: category.id}, card)"
                    >
                        <template v-slot:icon>
                            <i class="fal fa-plus fa-fw has-text-grey"></i>
                        </template>
                        <template v-slot:content>
                            <span class="has-text-grey">Add subcategory...</span>
                        </template>
                    </navigation-list-item>

                    <separator-list-item :key="'sep-' + category.id"/>
                </template>
            </card-list>
        </card-body>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardList from "@/TIER/components/CardList";
import CardToolbar from "@/TIER/components/CardToolbar";
import NavigationListItem from "@/TIER/components/NavigationListItem";
import SeparatorListItem from "@/TIER/components/SeparatorListItem";
import ContainerListItem from "@/TIER/components/ContainerListItem";

import {client as http} from "@/http_client";

export default {
    components: {
        CardHeader,
        CardBody,
        CardList,
        CardToolbar,
        NavigationListItem,
        SeparatorListItem,
        ContainerListItem
    },
    props: ['card', 'child', 'certificationId'],
    data() {
        return {
            categories: []
        };
    },
    methods: {
        loadCategories: function(force) {
            this.$emit('loading', true);
            http.get('course-categories/', {
                params: { certificationId: this.certificationId },
                force
            }).then(response => {
                this.categories = response.data;
                this.$emit('loading', false);
            }).catch(err => {
                console.log(err);
                this.$emit('loading', false);
            });
        },
        reload: function() {
            this.loadCategories(true);
        }
    },
    mounted: function() {
        this.loadCategories();
    }
};
</script>

<style lang="scss" scoped>
.pl-5 {
    padding-left: 2.5rem !important;
}
</style>
